import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import Dot from '@/components/ui/Dot.tsx';
import { buildExitEditingSummary } from './exitEditingSummary';

interface ExitEditingHeaderProps {
  /** Identyfikator nagłówka — `aria-labelledby` modala wskazuje na niego. */
  titleId: string;
  draft: ChangeDraftVm;
}

/** Nagłówek modala: tytuł i zdanie o stanie szkicu. */
const ExitEditingHeader = ({ titleId, draft }: ExitEditingHeaderProps) => (
  <div className="flex items-start gap-3 border-b border-accent-border bg-accent-100 px-7 pb-[18px] pt-[22px]">
    <Dot size="lg" className="mt-2" />
    <div>
      <h2
        id={titleId}
        className="text-xl font-extrabold tracking-[-.01em] text-ink"
      >
        Kończysz edycję rezerwacji
      </h2>
      <p className="mt-1.5 text-pretty text-[15px] leading-normal text-neutral-500">
        {buildExitEditingSummary(draft)}
      </p>
    </div>
  </div>
);

export default ExitEditingHeader;
